export const isoDate = (date: Date): string => date.toISOString().substr(0, 10) // YYYY-MM-DD
